/* eslint-disable @typescript-eslint/no-use-before-define */
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />x

export default class TestAlert {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    public onLoad(app: vf.Application, uiStage: vf.gui.Stage){
        
        let alert = new vf.gui.Alert();
        alert.x = 200;
        alert.y = 200;
        alert.title = 'title'; 
        alert.content = 'hello world!';
        alert.buttons = ['ok', 'cancel'];
        alert.duration = 5000;
        alert.on("CLICKBUTTON", this.alertClicked);
        uiStage.addChild(alert);

        let alert_icon = new vf.gui.Alert();
        alert_icon.x = 200;
        alert_icon.y = 200;
        alert_icon.title = 'title'; 
        alert_icon.icon = './assets/alert/icon.jpg';
        alert_icon.content = 'hello world!';
        alert_icon.buttons = ['ok', 'cancel'];
        alert_icon.duration = 5000;
        alert_icon.on("CLICKBUTTON", this.alertClicked);
        uiStage.addChild(alert_icon);

        let alert_custom = new vf.gui.Alert();
        alert_custom.x = 200;
        alert_custom.y = 200;
        alert_custom.title = 'title'; 
        alert_custom.background = './assets/alert/desk-bg.png';
        alert_custom.btnNormal = './assets/alert/button_normal.png';
        alert_custom.btnHover = './assets/alert/button_hover.png';
        alert_custom.btnPressed = './assets/alert/button_pressed.png';
        alert_custom.icon = './assets/alert/icon.jpg';
        alert_custom.content = 'hello world!';
        alert_custom.buttons = ['ok', 'cancel'];
        alert_custom.duration = 5000;
        alert_custom.on("CLICKBUTTON", this.alertClicked);
        uiStage.addChild(alert_custom);


        let label = new vf.gui.Label();
        label.text = '普通弹框';
        label.interactabled = true;
        label.on('click', ()=>{
            alert.show();
        })
        uiStage.addChild(label) 

        label = new vf.gui.Label();
        label.text = '带icon弹框';
        label.interactabled = true;
        label.y = 50;
        label.on('click', ()=>{
            alert_icon.show();
        })
        uiStage.addChild(label) 

        label = new vf.gui.Label();
        label.text = '自定义皮肤弹框';
        label.interactabled = true;
        label.y = 100;
        label.on('click', ()=>{
            alert_custom.show();
        })
        uiStage.addChild(label) 

        label = new vf.gui.Label();
        label.text = 'vf.gui.Alert.show(...)';
        label.interactabled = true;
        label.y = 150;
        label.on('click', ()=>{
            vf.gui.Alert.show(uiStage, 'Hello World!');
        })
        uiStage.addChild(label) 
    }   

    alertClicked(target: any, index: number){
        target.close();
        console.log('按钮被点击:', index)

        vf.gui.Scheduler.setInterval(1000, ()=>{
            console.log(111111)
        })
    }  
}